export interface IChatProviderResult {
  npi: string;
  providerName: string;
  credentials: string | null;
  specialty: string;
  providerGroup: string | null;
  gender: 'F' | 'M';
  initials: string;
  distance: number | null;
  address: string;
  phone: string | null;
  acceptingNewPatients: boolean;
  visitModes: string[];
  telehealth: boolean;
  areasOfFocus: string[];
  languages: string[];
  insuranceAccepted: string[];
  rating: number | null;
  ratingCount: number | null;
  photoUrl: string | null;
}

export interface IAppointmentSlotActionData {
  providerName: string;
  providerNPI: string;
  slots: Array<{
    slotId: string;
    date: string;
    time: string;
    duration: number;
    visitType: 'In-Person' | 'Telehealth' | string;
    available: boolean;
  }>;
}

export interface IFollowUpQueryActionData {
  queryText: string;
}

export interface ICaptureUserDetailsActionData {
  fields: string[];
}

export interface IAppointment {
  patientName: string;
  providerName: string;
  date: string;
  time: string;
  duration: number;
  location: string;
  visitType: 'In-Person' | 'Telehealth' | string;
}

export interface IReviewAppointmentActionData {
  appointmentDetails: IAppointment;
}

export interface IProviderResultsActionData {
  providerResults: IChatProviderResult[];
}

export type IChatAgentAction = {
  actionId: string;
  actionButtonTitle: string;
  data: Record<string, unknown>;
};

export interface IChatAgentResponse {
  textResponse: string;
  dateTime: string;
  userActions: IChatAgentAction[];
}

export const isChatAgentResponse = (value: unknown): value is IChatAgentResponse => {
  if (!value || typeof value !== 'object') {
    return false;
  }

  const candidate = value as Partial<IChatAgentResponse>;

  return (
    typeof candidate.textResponse === 'string' &&
    typeof candidate.dateTime === 'string' &&
    Array.isArray(candidate.userActions)
  );
};
